import { LoadingKey } from '../../app-active-loading/LoadingKey';
import { EndpointKey } from '../../http/EndpointKey';
import { isNewLoggedInAccount } from '../../http/endpointStateChecks';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { getEndpointStatus } from '../../store/http-responses/selectors';
import { getActiveLoading } from '../../store/loading-status/selectors';
import { ExperimentKeys } from '../ExperimentKeys';
import { GoogleSyncErrorStatus, GoogleSyncErrorStatusByHttpStatus } from './acq136Constants';
export const getIsActiveAndAssignedToVariantAcq136 = state => {
  return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0136);
};
export const getIsAcq136SignupRequestLoading = state => {
  const activeLoading = getActiveLoading(state);
  const isAcq136Variant = getIsActiveAndAssignedToVariantAcq136(state);
  const isAcq136VariantAndSignupRequestLoading = isAcq136Variant && activeLoading === LoadingKey.SignupRequest;
  return isAcq136VariantAndSignupRequestLoading;
};
export const getSignupAndLoginRequestsStatus = state => {
  const loginRequestEndpointStatus = getEndpointStatus(state, EndpointKey.LoginBeforeGoogleContactsSync);
  const isUserLoggedIn = isNewLoggedInAccount(state);

  if (loginRequestEndpointStatus) {
    const googleSyncErrorStatus = GoogleSyncErrorStatusByHttpStatus[loginRequestEndpointStatus];

    if (googleSyncErrorStatus === GoogleSyncErrorStatus.Completed && isUserLoggedIn) {
      return GoogleSyncErrorStatus.Completed;
    }

    return googleSyncErrorStatus;
  }

  return GoogleSyncErrorStatus.Loading;
};